import { createEntityAdapter } from '@reduxjs/toolkit';
import { ProposalParams } from '../proposals.types';

const adapter = createEntityAdapter<ProposalParams>();

export default adapter;
